import React from 'react'
import { usePublicPartners } from '../hooks/usePublicPartners'
import type { PublicPartner } from '../hooks/usePublicPartners'

const PartnersSection: React.FC = () => { 
  const { partners, loading, error } = usePublicPartners()

  // Ne rien afficher si pas de partenaires ou erreur
  if (error || (!loading && partners.length === 0)) return null

  return (
    <section className="partners-section" data-testid="partners-section">
      <h2 className="section-title">Nos partenaires</h2>

      {loading ? (
        <div className="partners-loading" data-testid="partners-loading">
          <span className="partners-spinner" />
        </div>
      ) : (
        <div className="partners-grid" data-testid="partners-grid">
          {partners.map((partner: PublicPartner) => (
            <PartnerCard key={partner.name} partner={partner} />
          ))}
        </div>
      )}
    </section>
  )
}

const PartnerCard: React.FC<{ partner: PublicPartner }> = ({ partner }) => {
  const content = (
    <div
      className="partner-card"
      style={{ '--partner-color': partner.color_code } as React.CSSProperties}
      data-testid="partner-card"
    >
      <div className="partner-logo-wrapper">
        {partner.logo_url ? (
          <img
            src={partner.logo_url}
            alt={`Logo ${partner.name}`}
            className="partner-logo"
            loading="lazy"
          />
        ) : (
          <div className="partner-logo-placeholder" aria-hidden="true">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" width="32" height="32">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
        )}
      </div>
      <span className="partner-name">{partner.name}</span>
    </div>
  )

  if (partner.website_url) {
    return (
      <a
        href={partner.website_url}
        target="_blank"
        rel="noopener noreferrer"
        className="partner-link"
        aria-label={`Visiter le site de ${partner.name}`}
      >
        {content}
      </a>
    )
  }

  return content
}

export default PartnersSection
